import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { validateTokenRequest } from "store/actions";

const withToken = (Component) => {
    return (props) => {
        const dispatch = useDispatch();

        const { isAuthenticated, loading, error } = useSelector((state) => {
          return (
            state.Auth || {
              isAuthenticated: false,
              loading: false,
              error: null,
            }
          );
        });

        const validateToken = useCallback(() => {
          dispatch(validateTokenRequest());
        }, [dispatch]);
      
        useEffect(() => {
          validateToken();
        }, [dispatch, window.location.pathname]);
            
        // if (!isAuthenticated && !loading) {
        //   return <Navigate to="/login" />;
        // }
      
        
        // if (error) {
        //   return (
        //     <div>
        //       <h3>Authentication Failed</h3>
        //       <p>{error}</p>
        //     </div>
        //   );
        // }
      
        
        return <Component {...props} />
    }
}

export default withToken; 